import { CancellationToken } from "@multiweb/types/multiweb";
import { IRoles } from "./IRolesAndICompetences";

/**
 * Umožňuje získání aktivních rolí a kompetencí,
 * změnit jejich stav a tento stav také ukládat
 * @includeToDoc
 */
export interface IUserSettingsManager {

    /**
     * Ukládá nastavené role a kompetence s jejich aktivnostmi.
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    saveData(cancellationToken?: CancellationToken): Promise<void>;

    /**
     * Vrací aktuální seznam id aktivních rolí a jejich kompetenčních okruhů.
     */
    getActiveRolesIds(cancellationToken?: CancellationToken): Promise<string[]>;

    /**
     * Vrací aktuální seznam rolí a jejich kompetenčních okruhů
     * včetně aktivnosti určených uživatelem
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getRoles(cancellationToken?: CancellationToken): Promise<IRoles>;

    /**
     * Nastavuje aktivnost role. Neprovádí však uložení změn do perzistentního úložiště. K tomu slouží @see saveData.
     * @param id identifikátor dané role
     * @param value příznak, zda má být role aktivní
     */
    updateRoleActivity(id: string, value: boolean): void;

    /**
     * Nastavuje aktivnost kompetenčního okruhu. Neprovádí však uložení změn do perzistentního úložiště. K tomu slouží @see saveData.
     * @param roleId identifikátor role ve které se nachází okruh
     * @param competenceId identifikátor okruhu
     * @param value hodnota zda má být role aktivní
     */
    updateCompetenceActivity(roleId: string, competenceId: string, value: boolean): void;

    /**
     * Nastaví aktivní okruhy.
     * @param cancellationToken Token
     */
    setActiveUserRoleRanges(cancellationToken?: CancellationToken): Promise<void>;
}

export class IUserSettingsManager {
    private static _methods: (keyof IUserSettingsManager)[] = ["saveData", "getActiveRolesIds", "getRoles", "updateRoleActivity", "updateCompetenceActivity"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null
            && !this._methods.some(value => typeof instance[value] !== "function");
    }
}
